import { useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { useHandlers } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import { StatusBanner } from './status-banner';

const COMPONENT = 'features:home.components.plan_reminders' satisfies I18nPrefix;

export function PlanReminders() {
  const env = useEnv();
  const { navigationHandler } = useHandlers();

  const needsConfirming = env.billing.has_pending_plan;
  const needsSelecting =
    !env.billing.has_pending_plan &&
    !env.billing.has_active_plan &&
    !env.team.is_partner &&
    !env.team.billing_linked_team_id;

  if (!needsConfirming && !needsSelecting) {
    return null;
  }

  return (
    <StatusBanner
      tone="blue"
      icon="infoCircle"
      title={t(`${COMPONENT}.title`)}
      description={t(needsConfirming ? `${COMPONENT}.confirm_plan` : `${COMPONENT}.select_plan`)}
      onClick={() => navigationHandler.navigateById('plan')}
    />
  );
}
